import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.InvestmentSetSortEnum>
) {
  const { pagination, sort, filter } = params;

  const {
    investmentSetList: { items: data, total },
  } = await sdk.getListInvestmentSet(
    filterSortPage({
      filter,
      sort,
      pagination,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { investmentSet: data } = await sdk.getOneInvestmentSet({
    id,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const investmentSet = types.dataProvider({
  getList,
  getOne,
});
